import { DEFAULT_BLOCK_TAG } from '../constants/editable-elements';

const wrapChildNodesIntoElement = (element, tag = DEFAULT_BLOCK_TAG) => {
  const { ownerDocument: liveDocument } = element;
  const newElement = liveDocument.createElement(tag);
  newElement.append(...element.childNodes);
  element.appendChild(newElement);
};

export default wrapChildNodesIntoElement;
